import Vue from 'vue';
import axios from 'axios';
import {mapState} from 'vuex';
Vue.prototype.$http = axios;

if (typeof Storage !== "undefined") {
  let UserToken = localStorage.getItem('token');
  if (UserToken) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = UserToken;
  }
}

Vue.prototype.$http.defaults.baseURL = 'https://api.shop.ucell.uz/api/admin/v1/';

// Vue.prototype.$http.defaults.baseURL = 'http://127.0.0.1:8001/api/admin/v1/';


Vue.prototype.$http.interceptors.request.use(
  (config) => {
    if ((config.method == 'put' ||
      config.method == 'post' ||
      config.method == 'delete') && config.url != 'log') {
        let data = {...config};
        console.log(Vue);
      axios.post('log', config);
    }
    return config
  },
  (error) => {
    return Promise.reject(error);
  }
);

Vue.prototype.$http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status == '401') {

    }
    if (error.response.status == '429') {

    }
    if (error.response.status == '500') {

    }
    if (error.response.status == '422') {

    }
    return Promise.reject(error);
  }
);

export default Vue.prototype.$http;
